import {ApolloClient} from 'apollo-client';
import {setContext} from 'apollo-link-context';
import {HttpLink} from 'apollo-link-http';
import {InMemoryCache, IntrospectionFragmentMatcher} from 'apollo-cache-inmemory';
import introspectionQueryResultData from './fragment-types.json';

// HTTP connexion to the API
const httpLink = new HttpLink({
    // You should use an absolute URL here
    uri: process.env.VUE_APP_GRAPHQL_BASE_URL, // eslint-disable-line
});

const authLink = setContext((_, {headers}) => {
    // get the authentication token from local storage if it exists
    const token = process.env.VUE_APP_GRAPHQL_TOKEN; // eslint-disable-line
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        }
    }
});

const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData,
});

// Cache implementation
const cache = new InMemoryCache({
    // dataIdFromObject: o => o.id,
    fragmentMatcher,
});

// Create the apollo client
export default new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
});
